import { render, staticRenderFns } from "./MostViewedCard.vue?vue&type=template&id=ae8c4446&"
import script from "./MostViewedCard.vue?vue&type=script&lang=js&"
export * from "./MostViewedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports